// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MentionAllPopover__button-af2320 {
  display: inline;
  cursor: pointer;
}

.MentionAllPopover__inline-c137b5 {
  display: inline;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/components/MentionAllPopover/styles.m.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,eAAA;AACF;;AAEA;EACE,eAAA;AACF","sourcesContent":[".button {\n  display: inline;\n  cursor: pointer;\n}\n\n.inline {\n  display: inline;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `MentionAllPopover__button-af2320`,
	"inline": `MentionAllPopover__inline-c137b5`
};
module.exports = ___CSS_LOADER_EXPORT___;
